<script>
import config from "./../config.js";
import { user } from './stores.js';
import Drawer from './components/Drawer.svelte';
import Alerts from './components/Alerts.svelte';
import Banner from './components/Banner.svelte';

let current_user;
const unsubscribe = user.subscribe(value => {
    current_user = value;
});

let title;
let body;
let icon = 'images/pwa/0ac52051-f294-5bfd-ff1b-60f6f2d88e36.webPlatform.png';
let response;

async function pushMessage(subscription) {
    // const { api } = config;
		const res = await fetch("/api/v2/subscription/push", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': 'Bearer ' + current_user.token
        },
			body: JSON.stringify({title: title, body: body, icon: icon})
    });
		
    if (res.ok) {
      const json = await res.json()
    } else {
      response = "HTTP-Error: " + res.status;
    }

    response = JSON.parse(json);
    
    return false;
}
</script>

<Drawer />
<Alerts />

<div class="container">
    <Banner visible={response}>
        <span slot="title">
            Response
        </span>
        <span slot="message">
            {response}
        </span>
    </Banner>
    <form on:submit="{pushMessage}" action="#push">
        <label>Title
            <input type="text" bind:value={title} />
        </label>
        <label>Text
            <input type="text" bind:value={body} />
        </label>
        <label>Icon
            <input type="text" bind:value={icon} />
        </label>
        <input type="submit" />
    </form>
</div>